import { h, Component } from 'preact'
import Table from '../table/Table'
import LinkIcon from './assets/linkIcon'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import ButtonControl from '../button-control'
import axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import Loader from '../ui-components/Loader'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import EmptyPage from '../empty-page/EmptyPage'

interface Author {
  id: string,
  name: string,
  avatar: string
}

interface Event {
  eventId: string,
  title: string,
  type: string,
  start_date: string,
  author: Author,
  destinationUrl: string
}

interface State {
  events: Array<Event>,
  error?: string,
  eventToDelete?: Event,
  isLoading: boolean,
  showDeleteConfirmationModal: boolean
}

interface Props {
  events: Array<Event>,
  defaultCdn: string,
  csrfToken: string
}

class EventOverview extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      events: props.events,
      isLoading: false,
      showDeleteConfirmationModal: false
    }
  }

  async deleteEvent () {
    const { eventToDelete } = this.state
    if (!eventToDelete) {
      this.setState({ error: 'Failed to delete an event.' })
      return
    }
    try {
      this.setState({ isLoading: true })
      await axios.delete(`/event/${eventToDelete.eventId}`, {
        data: { csrfToken: this.props.csrfToken },
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      this.setState({ events: this.state.events.filter((event: Event) => eventToDelete !== event) })
    } catch (err) {
      this.setState({ error: 'Failed to delete an event.' })
    }
    this.setState({ isLoading: false })
  }

  model = [{
    header: 'Title',
    accessor: 'title',
    cell: (event: Event) => <span class='event-link'><a href={`/event/${event.eventId}`} className='qa-title-link'>{event.title}</a> <a target='_blank' href={event.destinationUrl} className='qa-destination-link'><LinkIcon /></a></span>
  }, {
    header: 'Event type',
    accessor: 'type'
  }, {
    header: 'Event start date',
    accessor: 'startDate',
    cell: (event: Event) => {
      let customClasses = (new Date(event.start_date)) < new Date() ? 'past-event' : 'upcoming-event'
      return (
        <span className={`${customClasses} qa-starts-at`}>{(new Date(event.start_date)).toLocaleString()}</span>)
    } }, {
    header: 'Event creator',
    accessor: 'author',
    cell: (event: Event) => <span className='event-author qa-event-author'><UserAvatar user={event.author} /> <UserName user={event.author} /></span>
  }, {
    header: 'Delete event',
    accessor: 'delete',
    cell: (event: Event) => <ButtonControl title={'Delete'} variant={'danger'} class={`qa-event-delete-${event.eventId}`} onClick={() => this.setState({
      showDeleteConfirmationModal: true, eventToDelete: event
    })} />
  }]

  render (props: Props, { events, error, isLoading, showDeleteConfirmationModal }: State) {
    return (
      <div class='event-overview qa-event-overview'>
        <div class='control-header'>
          <h2>Events</h2>
        </div>
        {isLoading && <Loader />}
        {events.length > 0
          ? <div class='control-body container'>
            {
              error
                ? <AlertComponent messageType={'error'} message={error} isVisibleFor={5000} />
                : null
            }
            <Modal isOpen={showDeleteConfirmationModal} size='medium'>
              <ModalHeader title='Delete event?' onClose={() => this.setState({ showDeleteConfirmationModal: false })} />
              <ModalBody> If you delete an event, it's gone for good.</ModalBody>
              <ModalFooter>
                <ButtonControl
                  title='Delete'
                  variant='danger'
                  onClick={() => this.setState({ showDeleteConfirmationModal: false },
                    () => this.deleteEvent())} />
                <ButtonControl
                  title='Cancel'
                  onClick={() => this.setState({ showDeleteConfirmationModal: false })} />
              </ModalFooter>
            </Modal>
            <Table model={this.model} rows={events} rowId={'eventId'} />
          </div> : <EmptyPage
            img_src={`${props.defaultCdn}/images/events_empty_page.png`}
            header='No events found'
            text={'Seems like no one on your team has created any events. \n Start now by creating a new event.'}
            button={{ link: '/content/new/event', text: 'New event' }}
          />}
      </div>)
  }
}

export default EventOverview
